import React, { forwardRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import {
  CUSTOM_BUTTON_COLOR,
  CUSTOM_BUTTON_VARIANT,
  CustomButton,
} from 'src/components/CustomButton';
import { CustomTypography } from 'src/components/CustomTypography';
import pubsub, { PUBSUB } from 'src/lib/pubsub';

import { useEvents } from './useEvents';
import { useStyles } from './useStyles';

export const ScoreOnboardingHint = forwardRef(({ className, style, onNextClick }, ref) => {
  const styles = useStyles();
  const events = useEvents();

  const handleNext = () => {
    events.trackCloseClick();
    pubsub.publish(PUBSUB.OPEN_DETAILS_PANEL);
    onNextClick();
  };

  return (
    <div
      className={cx(styles.root, className)}
      ref={ref}
      style={style}
    >
      <CustomTypography className={styles.title}>
        Predict How Your Copy Will Perform Before You Publish
      </CustomTypography>
      <CustomTypography className={styles.description}>
        Anyword’s Performance Prediction scores, trained on millions of A/B tests, range from 0 to
        100 and predict how your content will perform before it's published.
      </CustomTypography>

      <CustomButton
        className={styles.button}
        variant={CUSTOM_BUTTON_VARIANT.text}
        color={CUSTOM_BUTTON_COLOR.primary}
        data-testid="onboardingScoreHintButton"
        onClick={handleNext}
      >
        Next
      </CustomButton>
    </div>
  );
});

ScoreOnboardingHint.propTypes = {
  className: PropTypes.string,
  onNextClick: PropTypes.func.isRequired,
};

ScoreOnboardingHint.defaultProps = {
  className: null,
};
